// @flow
import { put, takeLatest } from 'redux-saga/effects';
import * as ActionTypes from 'constants/ActionTypes';
import * as Actions from 'actions/user/user.tryonpackages';
import API from 'api';

function* getTryOnPackages(action: Object) {
  try {
    const response = yield API.get(
      'users/credits/packages',
      { withCredentials: true }
    );

    yield put(Actions.getTryOnPackagesSuccess(response));
  } catch (error) {
    yield put(Actions.getTryOnPackagesFailure(error));
  }
}

function* getTryOnFeaturedPackages(action: Object) {
  try {
    const response = yield API.get(
      'users/credits/packages/featured',
      { withCredentials: true }
    );

    yield put(Actions.getTryOnFeaturedPackagesSuccess(response));
  } catch (error) {
    yield put(Actions.getTryOnFeaturedPackagesFailure(error));
  }
}

function* verifyTryOnCheckout(action: Object) {
  try {
    const response = yield API.post(
      'users/credits/checkout/verify',
      action.payload,
      { withCredentials: true }
    );

    yield put(Actions.verifyTryOnCheckoutSuccess(response));
  } catch (error) {
    yield put(Actions.verifyTryOnCheckoutFailure(error));
  }
}

function* createTryOnOrder(action: Object) {
  try {
    const response = yield API.post(
      'users/credits/checkout/create-order',
      action.payload,
      { withCredentials: true }
    );

    yield put(Actions.createTryOnOrderSuccess(response));
  } catch (error) {
    yield put(Actions.createTryOnOrderFailure(error));
  }
}

function* completeTryOnOrder(action: Object) {
  try {
    const response = yield API.post(
      'users/credits/checkout/complete',
      action.payload,
      { withCredentials: true }
    );

    yield put(Actions.completeTryOnOrderSuccess(response));
  } catch (error) {
    yield put(Actions.completeTryOnOrderFailure(error));
  }
}

function* getTryOnOrders(action: Object) {
  try {
    const params = action.payload || { limit: 20, skip: 0 };
    const response = yield API.get(
      `users/credits/orders?limit=${params.limit || 20}&skip=${params.skip || 0}`,
      { withCredentials: true }
    );

    yield put(Actions.getTryOnOrdersSuccess(response));
  } catch (error) {
    yield put(Actions.getTryOnOrdersFailure(error));
  }
}

function* getTryOnOrderDetail(action: Object) {
  try {
    const response = yield API.get(
      `users/credits/orders/${action.payload}`,
      { withCredentials: true }
    );

    yield put(Actions.getTryOnOrderDetailSuccess(response));
  } catch (error) {
    yield put(Actions.getTryOnOrderDetailFailure(error));
  }
}

function* createTryOnPaymentOrder(action: Object) {
  try {
    const response = yield API.post(
      '/payments/credits-order',
      action.payload,
      { withCredentials: true }
    );

    yield put(Actions.createTryOnPaymentOrderSuccess(response));
  } catch (error) {
    yield put(Actions.createTryOnPaymentOrderFailure(error));
  }
}

function* verifyTryOnPayment(action: Object) {
  try {
    const response = yield API.post(
      '/payments/credits-verify',
      action.payload,
      { withCredentials: true }
    );

    yield put(Actions.verifyTryOnPaymentSuccess(response));
  } catch (error) {
    yield put(Actions.verifyTryOnPaymentFailure(error));
  }
}

export default function* TryOnPackagesSaga(): Generator<*, *, *> {
  yield takeLatest(ActionTypes.GET_TRYON_PACKAGES_START, getTryOnPackages);
  yield takeLatest(ActionTypes.GET_TRYON_FEATURED_PACKAGES_START, getTryOnFeaturedPackages);
  yield takeLatest(ActionTypes.VERIFY_TRYON_CHECKOUT_START, verifyTryOnCheckout);
  yield takeLatest(ActionTypes.CREATE_TRYON_ORDER_START, createTryOnOrder);
  yield takeLatest(ActionTypes.COMPLETE_TRYON_ORDER_START, completeTryOnOrder);
  yield takeLatest(ActionTypes.GET_TRYON_ORDERS_START, getTryOnOrders);
  yield takeLatest(ActionTypes.GET_TRYON_ORDER_DETAIL_START, getTryOnOrderDetail);
  yield takeLatest(ActionTypes.CREATE_TRYON_PAYMENT_ORDER_START, createTryOnPaymentOrder);
  yield takeLatest(ActionTypes.VERIFY_TRYON_PAYMENT_START, verifyTryOnPayment);
}
